import React from 'react';
import { connect } from 'react-redux'
import '../login.css';
import Header from '../Components/Header/HeaderUnauthorized';
import { requestIdentityVerification, identityVerifiedRoutines } from '../actions/authActions';
import { showGlobalMessage } from '../actions/environmentActions';
import TextField from 'material-ui/TextField';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import RaisedButton from 'material-ui/RaisedButton';
import { resourceApi } from '../utils/fetchUtil';
import { clearToken } from '../utils/tokenUtil';
import { hashHistory } from 'react-router';


class IdentityPage extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      lastname: "",
      last4: "",
      month: "",
      day: "",
      year: "",
      heading: "We are required to match your identity with the records your employer has on file."
    };
  }



  componentDidMount() {

    const { lastName, last4SSN, dobMonth, dobDay, dobYear } = this.props.auth;

    this.setState({
      lastname: lastName,
      last4: last4SSN,
      month: dobMonth,
      day: dobDay,
      year: dobYear
    });

    //this.props.checkToken();

    if (window.localLabels) {
      var pageLabel = window.localLabels.filter((f) => {
        return (f.page === "reg-2");
      })

      if (pageLabel.length >= 0) {
        this.setState({
          heading: pageLabel[0].label
        })
      }
    }

  }


  identify = () => {

    var self = this;

    const creds = {
      lastname: this.state.lastname.trim(),
      last4: this.state.last4.trim(),
      month: this.state.month,
      day: this.state.day,
      year: this.state.year,
      whiteLabelKey: this.getWhiteLabelKey(),
    };

    //dispatch(requestIdentityVerification(creds));
    this.props.requestIdentityVerification(creds);

    let config = {
      method: 'POST',
      url: 'auth/identify',
      headers: { 'Content-Type': 'application/json' },
      data: {
        FirstName: creds.firstname,
        LastName: creds.lastname,
        Last4SSN: creds.last4,
        DOBMonth: creds.month,
        DOBDay: creds.day,
        DOBYear: creds.year,
        WhiteLabelKey: creds.whiteLabelKey,
      }
    };



    return resourceApi(config)
      .then(object => {
        if (object.data) {
          self.props.showGlobalMessage("It looks like there is already a login associated with the member information entered. Try recovering your password or contact support for further assistance!");
        } else {
          self.props.identityVerifiedRoutines();

          self.props.showGlobalMessage("Your account is now active!");
          hashHistory.push('home');
        }
      })
      .catch(function (error) {
        self.props.showGlobalMessage("We were unable to verify your identity. Please check your information and try again.");
      });

  }

  getWhiteLabelKey() {
    if (window.COMPANY_ID != undefined) {
      return window.COMPANY_ID;
    }
    else {
      return 0;
    }
  }

  firstnameChange = (event, value) => {
    this.setState({ firstname: value });
  }

  lastnameChange = (event, value) => {
    value = value.replace(/[\u2018\u2019\u0060\u00B4]/g, "'")
    this.setState({ lastname: value });
  }

  last4Change = (event, value) => {
    this.setState({ last4: value });
  }

  monthChange = (event, index, value) => {
    this.setState({ month: value });
  }

  dayChange = (event, index, value) => {
    this.setState({ day: value });
  }

  yearChange = (event, index, value) => {
    this.setState({ year: value });
  }

  render() {

    const dayItems = [];
    for (var i = 1; i < 32; i++) {
      dayItems.push(<MenuItem key={i} value={i} primaryText={i.toString()} />);
    }

    const yearItems = [];
    var d = new Date();
    var n = (d.getFullYear() - 17); // at least 18 years old to use.
    for (var i = n; i >= (n - 70); i--) {
      yearItems.push(<MenuItem key={i} value={i} primaryText={i.toString()} />);
    }


    return (
      <div>
        <Header>
          <span className="white" >Verify Identity</span>
        </Header>
        <div className="container" >
          <div style={{ textAlign: 'center' }}>
            <div className="container" >
              {(!this.props.isIdentified) && (
                <div>
                  <p className="white truenoLight" style={{ fontSize: 15 }}>{this.state.heading}</p>
                  <div className="container" style={{ textAlign: 'left' }}>
                    {/*<TextField hintText="Firstname"  value={this.state.firstname} onChange={this.firstnameChange} fullWidth="true" inputStyle={{color:"#fff"}} hintStyle={{color:"#fff"}} />
                    <br />
                    <br />*/}
                    <TextField hintText="Last name" value={this.state.lastname} onChange={this.lastnameChange} fullWidth={true} inputStyle={{ color: "#fff" }} hintStyle={{ color: "#fff" }} />
                    <br />
                    <br />
                    <p className="white">Date of Birth</p>
                    <SelectField hintText="Month" value={this.state.month} onChange={this.monthChange} labelStyle={{ color: '#fff' }} inputStyle={{ color: "#fff" }} hintStyle={{ color: "#fff" }} >
                      <MenuItem value={1} primaryText="January" />
                      <MenuItem value={2} primaryText="February" />
                      <MenuItem value={3} primaryText="March" />
                      <MenuItem value={4} primaryText="April" />
                      <MenuItem value={5} primaryText="May" />
                      <MenuItem value={6} primaryText="June" />
                      <MenuItem value={7} primaryText="July" />
                      <MenuItem value={8} primaryText="August" />
                      <MenuItem value={9} primaryText="September" />
                      <MenuItem value={10} primaryText="October" />
                      <MenuItem value={11} primaryText="November" />
                      <MenuItem value={12} primaryText="December" />
                    </SelectField>

                    <SelectField hintText="Day" value={this.state.day} onChange={this.dayChange} labelStyle={{ color: '#fff' }} maxHeight={300} inputStyle={{ color: "#fff" }} hintStyle={{ color: "#fff" }}  >
                      {dayItems}
                    </SelectField>

                    <SelectField hintText="Year" value={this.state.year} onChange={this.yearChange} labelStyle={{ color: '#fff' }} maxHeight={300} inputStyle={{ color: "#fff" }} hintStyle={{ color: "#fff" }}  >
                      {yearItems}
                    </SelectField>

                    <p className="white">Last 4 Digits of SSN</p>
                    <table style={{ width: 200, marginTop: -10 }}>
                      <tbody>
                        <tr>
                          <td style={{ fontSize: 16, width: 90 }}>
                            <p className="white">XXX<span style={{ paddingLeft: 10 }}></span>-<span style={{ paddingLeft: 10 }}></span>XX<span style={{ paddingLeft: 10 }}></span>-<span style={{ paddingLeft: 10 }}></span></p>
                          </td>
                          <td>
                            <TextField hintText="" maxLength={4} value={this.state.last4} onChange={this.last4Change} inputStyle={{ color: "#fff" }} hintStyle={{ color: "#fff" }} style={{ width: 100 }} />
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <br />
                    {!this.props.isFetching && (
                      <RaisedButton label="Continue" primary={true} onClick={this.identify} fullWidth={true} style={{ height: 45 }} labelStyle={{ fontSize: '26px' }} />
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
};


const mapDispatchToProps = (dispatch) => {
  return {
    requestIdentityVerification: (creds) => {
      dispatch(requestIdentityVerification(creds));
    },
    identityVerifiedRoutines: () => {
      dispatch(identityVerifiedRoutines());
    },
    showGlobalMessage: (message) => {
      dispatch(showGlobalMessage(message));
    },
    checkToken: () => {
      // the result of this method if the user is unauthorized/session timeout
      // is to for the return of a 403 so the user is forced to login.
      let config = {
        method: 'GET',
        url: 'member/tokenCheck'
      };

      return resourceApi(config, dispatch)
    }
  }
}


function mapStateToProps(state) {

  const auth = state.thisApp.auth;

  return {
    auth
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IdentityPage)


// WEBPACK FOOTER //
// ./src/Pages/Identity.js